import '../sass/app.scss';
import {createInertiaApp} from '@inertiajs/vue3';
import {createSSRApp, h} from 'vue';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import globalHelpers, {pushDataLayer} from '@global/js/Mixins/helpers';
import GoogleTagManager from '@global/js/Plugins/GoogleTagManager';
import timonHelpers from '@timon/js/Mixins/helpers';
import {ZiggyVue} from 'ziggy';
import DefaultLayout from './Layout/Default.vue';
import store from './store/index.js';

createInertiaApp({
  progress: false,
  resolve: name => {
    return resolvePageComponent(`./Templates/${name}.vue`, import.meta.glob('./Templates/**/*.vue', {eager: true}))
      .then(page => {
        if (page.default.layout === undefined) {
          page.default.layout = DefaultLayout;
        }
        return page;
      });
  },

  async setup ({el, App, props, plugin}) {
    const ssrWorking = el.childNodes.length > 0;
    if (!props.initialPage.props.isProduction && !ssrWorking) {
      if (!props.initialPage.props.inertiaIsEnabled) {
        console.info('[dev] SSR not working, but is not enabled.');
      } else {
        const error = 'app.js - SSR not working?! Check the (docker) logs for any SSR error. Preventing the app from client-side rendering.';
        console.error(error);

        const errorElement = document.createElement('div');
        errorElement.innerHTML = `<h1><b>${error}</b></h1>`;
        el.appendChild(errorElement);

        throw error;
      }
    }

    const createdApp = createSSRApp({render: () => h(App, props)});

    createdApp
      .use(plugin)
      .use(store)
      .use(ZiggyVue)
      .mixin(globalHelpers)
      .mixin(timonHelpers)
      .use(GoogleTagManager)
      .mount(el);

    pushDataLayer({
      originalLocation: document.location.protocol + '//' +
        document.location.hostname +
        document.location.pathname +
        document.location.search,
    });
  },
});
